var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block head"},[_c('h3',[_vm._v("Einstellungen")]),_vm._l((_vm.suchpattern),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(item.memberEmail)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }